export default "__VITE_ASSET__DZu0Xuhq__"